export const all_routes = {
  dashboard: "/admin-dashboard",

  prizeList: "/prize-list",
  prizeDetails: "/prize-details",
  addPrize: "/add-prize",
  editPrize: "/edit-prize",

  tierList: "/tier-list",
  addTier: "/add-tier",
  editTier: "/edit-tier",
  tierDetails: "/tier-details",

  groupTierList: "/group-tier-list",
  addGroupTier: "/add-group-tier",
  editGroupTier: "/edit-group-tier",
  groupTierDetails: "/group-tier-details",

  spinConfig: "/spin-config",
  tokenConfig: "/token-config",
  spinHistory: "/spin-history",
  rankList: "/rank-list",

  userList: "/user-list",
  userDetails: "/user-details",
  addUser: "/add-user",
  editUser: "/edit-user",

  signin: "/signin"
};
